/* eslint-disable @typescript-eslint/naming-convention */
export const API_PATH_APPS = {
  API_PERSONAL_INSURANCE: 'api-personal-insurance'
};
